/**
 *  ・クラス名
 *    顧客マスタモデル
 *  ・概要
 *    概要を記述
 *  ・更新履歴
 *    yyyy/mm/dd 新規作成
 */
/* eslint-disable @typescript-eslint/camelcase */
//import { DateTime } from 'luxon';
import BaseModel from './baseModel';

import Customer from '@/models/data/customer';
// import CustomerDepartment from '@/models/data/customerDepartment';
// import LeasingCompany from '@/models/data/leasingCompany';
// import Rate from '@/models/data/rate';
import Employee from '@/models/data/employee';
// import ServiceType from '@/models/data/serviceType';
// import Commodity from '@/models/data/commodity';
// import Material from '@/models/data/material';
// import DatailAddInput from '@/models/data/datailAddInput';
// import EstimateInformation from '@/models/data/estimateDetail';
// import Grouping from '@/models/data/grouping';
// import Form from '@/models/data/form';

import {
  StatusActions,
  ItemActions,
  Items,
  FieldsInfo,
  FieldChildrenProp,
  MasterData,
  GetInputFieldsActons,
  GetItemDetailsResponse
} from '@/services/hexabase/types';
//import { AutoNumberDefine, editFinishText } from '@/constants/customer/customer';
import { orderAppealAction } from '@/constants/form/inputCheck';
import { DefaultErrorCode } from '@/constants/error';
//import router from '@/router';

interface RegistData {
  item: { [k: string]: string };
  return_item_result: boolean;
  related_ds_items: { [k: string]: RelatedItems[] };
  is_force_update?: boolean;
}
interface RelatedItems {
  item: { [k: string]: any };
  operation: number;
  action_id?: string;
}
interface Rules {
  id: string;
  rule: string[];
  referenceField?: {
    id: string;
    rule: string;
  }[];
}
interface UpdateData {
  item?: { [k: string]: string };
  rev_no?: number;
  return_item_result?: boolean;
  related_ds_items?: { [k: string]: Related[] };
  comment?: string;
}
interface Related {
  operation?: number;
  action_id?: string;
  rev_no?: number;
  item?: { [k: string]: string };
}
export default class CustomerModel extends BaseModel {
  private customer = new Customer();
  // private customerDepartment = new CustomerDepartment();
  // private leasingCompany = new LeasingCompany();
  // private rate = new Rate();
  private employee = new Employee();
  // private serviceType = new ServiceType();
  // private commodity = new Commodity();
  // private material = new Material();
  // private datailAddInput = new DatailAddInput();
  // private estimateInformation = new EstimateInformation();
  // private grouping = new Grouping();
  // private management = new Management(); // ログイン時にStoreで管理するため不要
  // private form = new Form();

  private masterData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};

  constructor() {
    super();
  }

  /**
   * 各種入力フォームで使用する各マスタ情報を取得
   * プロパティーに格納します
   * @param none
   * @returns void
   */
  public async getMasterData() {
    const mData: { [k: string]: { [k: string]: Array<{ [k: string]: string }> } } = {};
    // 登録用なので無効情報は引かない
    this.customer.payload?.conditions?.push({ id: 'Status', search_value: ['customer_valid'] });

    [
      mData['m_customer'], 
      mData['m_employee']
    ] = await Promise.all([
      this.customer.getFormatData(),
      this.employee.getFormatData()
    ]);

    this.masterData = mData;
  }

  /**
   * マスタ情報を取得します
   * @returns {array} - マスタ情報配列
   */
  public getMaster() {
    return this.masterData;
  }

  public getField(appId: string, dId: string) {
    return this.getFieldsData(appId, dId).then(data => data);
  }

  /**
   * ステータスアクションを実行します
   * @param registData - 登録用データや配列
   * @param workSpaceId - ワークスペースID
   * @param mainDatastoreId - 見出しデータストアID
   * @param linkDatastoreId - 明細データストアID
   * @param itemId - 更新対象アイテムID
   * @param headAction - 実行可能な見出しアクションリスト
   * @param detailAction - 実行可能な明細アクションリスト
   * @param revNumber - アイテムのリビジョン番号
   * @param buttonType - アクション名（display_id）
   * @param user - ユーザー情報（申請者等の登録時に使用）
   */
  public async execStatusAction(
    registData: RegistData,
    workSpaceId: string,
    mainDatastoreId: string,
    linkDatastoreId: string,
    itemId: string,
    headAction: Array<StatusActions | ItemActions>,
    detailAction: Array<StatusActions | ItemActions>,
    revNumber: number,
    buttonType: string,
    user?: { [k: string]: string }
  ) {
    let dialogText = '';
    try {
      const findAction = headAction.find(action => action.display_id === buttonType);
      if (findAction === undefined || findAction.display_id === undefined)
        throw 'アクションが見つかりません';
      registData = {
        ...registData,
        ...{
          comment: `「${findAction.action_name}」アクションを実行`,
          return_item_result: true,
          rev_no: revNumber
        }
      };
      // ダイヤログ内文言変更
      dialogText = `「${findAction.action_name}」を実行しました`;

      const userIid = user === undefined ? '' : user.i_id;
      registData = {
        ...registData,
        ...this.updateActionFields(buttonType, registData, userIid)
      } as RegistData;

      const findDetailAction = detailAction.find(
        action => action.display_id === buttonType.replace('sample_', 'sample_detail_')
      );

      const createAction = detailAction.filter(action => action.crud_type === '1');
      const findDetailCreateAction =
        createAction !== undefined
          ? createAction.find(action => {
              const type = buttonType.replace('sample_', '');
              if (action.display_id?.includes(type)) {
                return true;
              }
              return false;
            })
          : undefined;

      if (findDetailAction !== undefined) {
        registData.related_ds_items[linkDatastoreId].map(item => {
          if (item.operation === 2) item['action_id'] = findDetailAction['action_id'];
          if (findDetailCreateAction !== undefined && item.operation === 1) {
            item['action_id'] = findDetailCreateAction['action_id'];
          }
          return item;
        });
      }

      const result = await this.changeStatus(
        workSpaceId,
        mainDatastoreId,
        itemId,
        findAction.display_id,
        registData
      );
      this.apiErrorHandle('EXECUTEACTION', result);

      // 削除ボタンの場合は一覧に遷移させる
      // if (buttonType === 'order_preparing_delete'){
      //   const routing = router.options.routes?.find(v => v.name === 'OrderList')
      //   return { text: dialogText, button: { id: 1, type: 'routing', name: 'route', route: routing?.path, value: '検索一覧へ' }}
      // }

      return { text: dialogText };
    } catch (error) {
      const message =
        typeof error === 'string' ? error : this.getErrMessage('DEFAULT', DefaultErrorCode);
      return {
        error: true,
        text: message,
        button: { id: 1, type: 'reload', name: 'cancel', value: '閉じる' }
      };
    }
  }

  /**
   * 押下したアクションボタン毎に
   * 保存が必要なフィールドに値を設定いたします
   * @param buttonType - アクション名（display_id）
   * @param registData - 登録用デーや配列
   * @param userMasterIid - 社員マスタのユーザーid（アイテムID）
   */
  private updateActionFields(
    buttonType: string,
    registData: RegistData | UpdateData,
    userMasterIid: string
  ) {
    /* eslint-disable @typescript-eslint/camelcase */
    switch (buttonType) {
      case 'customer_regist': {
        //
        break;
      }
      case 'customer_valid_update': {
        //
        break;
      }
      case 'customer_valid_delete': {
        //
        break;
      }
      default: {
        break;
      }
    }
    return registData;
  }

  /**
   * ステータスボタンリストの加工 （wrapper）
   * 各ボタンの活性・非活性等を定義ファイルと付け合わせる
   * @param {string} userId - 社員マスタ内のログインユーザーのアイテムID
   * @param {Array<StatusActions>} statusActionList - ステータスアクションリスト
   * @param {string} part - ドメイン名
   * @param {Array<FieldsInfo>} itemData - アイテム詳細データ
   * @param {string} buttonType - 押下されたボタンアクション
   * @returns {Array} ステータスリスト
   */
  public statusButtonList(
    statusActionList: Array<StatusActions>,
    itemData?: Array<FieldsInfo>,
    buttonType?: string
  ): Array<StatusActions> {
    // 押下ボタンのタイプがある場合押下アクション以外は非活性
    if (statusActionList.length > 0 && this.isNullOrUndefined(buttonType)) {
      return statusActionList.map(action => {
        action.isDisable = action.display_id !== buttonType || false;
        return action;
      });
    }

    // if (buttonDefine['order'] === undefined) return statusActionList;
    // return this.createStatusButtonList(userId, statusActionList, buttonDefine['order'], itemData);
    return statusActionList;
  }

  isNullOrUndefined(prop: any) {
    return prop !== undefined && prop !== null;
  }

  // /**
  //  * 合計値計算パネルの値から明細合計金額・税額取得
  //  * @param summary 合計値計算パネルに渡すオブジェクト
  //  * @returns number[]
  //  */
  // public getSummaryArray(summary: Array<{ [k: string]: any }>): number[] {
  //   const result: number[] = [0, 0];
  //   for (const index in summary) {
  //     if (summary[index].data.length > 0) {
  //       result[index] = (summary[index].data as number[]).reduce((acc, value) => acc + value);
  //     }
  //   }
  //   return result;
  // }

  /**
   * コンポーネント間のマスターセレクト関連コンポーネントの
   * 値絞込みを行う（マスターセレクト、セレクトエリア、コンボBOX）
   *
   * @param data - フィールド情報
   * @param filterSelect - 絞込みを行う定義
   * @param master - マスタデータ
   * @returns フィールド情報
   */
  public narrowDownSelectOptin(
    data: FieldChildrenProp[],
    filterSelect: { key: string; target: string }[],
    master: MasterData
  ) {
    if (filterSelect.length > 0) {
      for (const index in filterSelect) {
        if (filterSelect[index].key === undefined || filterSelect[index].target === undefined)
          continue;
        const findRow = data.find(field => field.display_id === filterSelect[index].key);
        if (findRow !== undefined) {
          data = this.getNarrowDownSelectOptin(
            data,
            master,
            {
              name: filterSelect[index].key,
              value: findRow.props?.value !== null ? findRow.props?.value.item_id : ''
            },
            filterSelect[index].key,
            filterSelect[index].target
          );
        }
      }
    }
    return data;
  }

  /**
   * 見出しデータの入力必須項目を取得します
   * @param dId - データストアID
   * @param action - 押下されたアクション情報
   * @returns {[k: string]: any} - 入力必須情報
   */
  public async getMainRequired(dId: string, action: { [k: string]: string | number }) {
    const inputFields = await this.getFieldsByActionId(dId, action.action_id as string);
    const orderInput: { [k: string]: any } = this.findRequired(inputFields);
    return orderInput;
  }

  /**
   * 明細データの入力必須項目を取得します
   * @param projectId - データストアID
   * @param dId - データストアID
   * @param items - アイテム情報
   * @param actionName - 押下されたアクションdisplay_id
   * @returns {[k: string]: any} - 入力必須情報
   */
  public async getLinkRequired(projectId: string, dId: string, items: Items[], actionName: string) {
    let detailData: any = {};
    for (const index in items) {
      const item = items[index];
      if (item.item_links !== undefined && item.item_links.links.length > 0) {
        const linkItem = item.item_links.links.find(link => link.d_id === dId);
        if (linkItem) {
          detailData = (await this.getLinkedItems(
            projectId,
            dId,
            linkItem.items[0].i_id
          )) as GetItemDetailsResponse;
          if (detailData.status_actions !== null) break;
        }
      }
    }

    let orderDetailInput: { [k: string]: any } = {};
    if (Object.keys(detailData).length > 0) {
      const detailAction = (detailData.status_actions as Array<StatusActions>).find(
        action => action.display_id === actionName
      );
      if (detailAction !== undefined) {
        const detailInputFields = await this.getFieldsByActionId(dId, detailAction!.action_id);
        orderDetailInput = this.findRequired(detailInputFields);
      }
    }

    return orderDetailInput;
  }

  /**
   * APIから取得した入力必須データをリストに追加します
   * @param fields - GetInputFieldsActons
   * @returns {[k: string]: any} - 必須項目情報
   */
  private findRequired(fields: GetInputFieldsActons) {
    const result: { [k: string]: any } = {};
    const fieldsSetting = fields.action_fields;
    for (const property in fieldsSetting) {
      if (fields.action_field_settings[property].mandatory)
        result[fieldsSetting[property].display_id] = fields.action_field_settings[property];
    }
    return result;
  }

  // /**
  //  * 更新前チェック：顧客マスタ重複判定
  //  * @param checkName 顧客名
  //  * @param checkTelephon 電話番号
  //  * @returns 真偽型、重複が「存在する場合」Trueを返す
  //  */
  // public isInsertCheckCustomer(checkName: string, checkTelephon: string) {
  //   //
  //   return false;
  // }

  /**
   * 一括処理実行
   * @param items - アイテム情報
   * @param projectId - アプリケーションID
   * @param mainDId - 見出しデータストアID
   * @param relatedDId - 明細データストアID
   * @param orderInput - 見出しデータ必須項目
   * @param orderDetailInput - 明細データ必須項目
   * @param action - 押下されたアクション情報
   * @returns 更新を失敗したアイテム情報
   */
  public async multipleProcesses(
    items: Items[],
    projectId: string,
    mainDId: string,
    relatedDId: string,
    orderInput: { [k: string]: any },
    orderDetailInput: { [k: string]: any },
    action: { [k: string]: string | number },
    userId: string
  ) {
    const errors: Items[] = [];
    const isDelete = (action.display_id as string).includes('delete') || false;
    const relateActionName = this.detailActionName(action.display_id as string);
    const prefix = 'SAMPLE_';

    for (const i in items) {
      let hasError = false;
      let updateData: UpdateData = {};

      // const data = items[i] as any;

      // const isApplicationNo =
      //   this.isExsist(data[AutoNumberDefine.appNumber.displayId]) &&
      //   data[AutoNumberDefine.appNumber.displayId].length > 0 ? true : false;
      // const isOrderNo =
      //   this.isExsist(data[AutoNumberDefine.orderNumber.displayId]) &&
      //   data[AutoNumberDefine.orderNumber.displayId].length > 0 ? true : false;

      // 見出しデータの必須項目確認
      // 入力がないものはkeyに入ってこない為、keyの存在確認
      const itemIds = Object.keys(items[i]);
      const targetIds = Object.keys(orderInput);
      for (const displayId in targetIds) {
        if (!itemIds.includes(targetIds[displayId])) {
          const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}MAIN_MANDATORY`);
          errors.push({ ...items[i], ...{ error_message: errMessage } });
          hasError = true;
          break;
        }
      }
      if (hasError) continue;

      // データベース参照型の場合nullがあり得るため確認
      for (const [key, value] of Object.entries(items[i])) {
        if (
          orderInput[key] !== undefined &&
          orderInput[key].mandatory &&
          (value === '' || value === null)
        ) {
          const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}MAIN_MANDATORY`);
          errors.push({ ...items[i], ...{ error_message: errMessage } });
          hasError = true;
          break;
        }
      }
      if (hasError) continue;

      // 上へ発注申請する際は、自分が申請した発注を承認できない
      if (orderAppealAction.includes(action.display_id as string)) {
        // if (
        //   items[i]['lookup_items'] !== undefined &&
        //   items[i]['lookup_items']![OrderCheckApplicantFieldId] &&
        //   items[i]['lookup_items']![OrderCheckApplicantFieldId].i_id === userId
        // ){
        //   const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}USER_APPLY`);
        //   errors.push({...items[i], ...{error_message: errMessage}});
        //   hasError = true;
        // }
      }
      if (hasError) continue;

      // 関連データが存在するか確認
      const linkItem = await this.getLinked(projectId, mainDId, items[i].i_id, relatedDId);
      if (
        !isDelete &&
        (linkItem.has_error || linkItem.result['t_sample_detail'].items.length === 0)
      ) {
        const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}NOT_EXIST`);
        errors.push({ ...items[i], ...{ error_message: errMessage } });
        continue;
      }

      // 関連データの必須項目確認
      for (const index in linkItem.result['t_sample_detail'].items) {
        const item = linkItem.result['t_sample_detail'].items[index];

        // データの必須項目確認
        // 入力がないものはkeyに入ってこない為、keyの存在確認
        const itemIds = Object.keys(item);
        const targetIds = Object.keys(orderDetailInput);
        for (const displayId in targetIds) {
          if (!itemIds.includes(targetIds[displayId])) {
            const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}DETAIL_MANDATORY`);
            errors.push({ ...items[i], ...{ error_message: errMessage } });
            hasError = true;
            break;
          }
        }
        if (hasError) break;

        // データベース参照型の場合nullがあり得るため確認
        for (const [key, value] of Object.entries(item)) {
          if (
            orderDetailInput[key] !== undefined &&
            orderDetailInput[key].mandatory &&
            (value === '' || value === null)
          ) {
            const errMessage = this.getErrMessage('BATCH_PROCESSING', `${prefix}DETAIL_MANDATORY`);
            errors.push({ ...items[i], ...{ error_message: errMessage } });
            hasError = true;
            break;
          }
        }
        if (hasError) break;
      }
      if (hasError) continue;

      const updateLinkedData: { [k: string]: any }[] = [];
      for (const relatedIndex in linkItem.result.t_sample_detail.items) {
        const detail = await this.getLinkedItems(
          projectId,
          relatedDId,
          linkItem.result.t_sample_detail.items[relatedIndex].i_id
        );
        const selectAction = (detail.status_actions as { [k: string]: string }[]).find(
          action => action.display_id === relateActionName
        );
        if (selectAction === undefined) {
          break;
        }
        updateLinkedData.push({
          operation: 2,
          action_id: selectAction.action_id,
          i_id: linkItem.result.t_sample_detail.items[relatedIndex].i_id,
          rev_no: Number(linkItem.result.t_sample_detail.items[relatedIndex].rev_no)
        });
      }

      updateData.rev_no = Number(items[i].rev_no);
      updateData.return_item_result = true;
      updateData = this.updateActionFields(action.display_id as string, updateData, userId);

      // // 発注申請の場合は申請番号追加
      // if (action.display_id === ApplicationNumberIssuanceActionId && !isApplicationNo) {
      //   const autoNumber = await this.getAutoNumber(projectId, mainDId, AutoNumberDefine.appNumber.autoFieldId, {});;
      //   const id = AutoNumberDefine.appNumber.displayId;
      //   if (updateData.item === undefined) updateData.item = {} as {[k:string]: string};
      //   updateData.item[id] = autoNumber.result.value;
      //   updateLinkedData = updateLinkedData.map(item => {
      //     item.item = {};
      //     item.item[id] = autoNumber.result.value;
      //     return item;
      //   });
      // }

      // // 発注決裁の場合は発注番号追加
      // if (action.display_id === OrderNumberIssuanceActionId && !isOrderNo) {
      //   const autoNumber = await this.getAutoNumber(projectId, mainDId, AutoNumberDefine.orderNumber.autoFieldId, {});
      //   const id = AutoNumberDefine.orderNumber.displayId;
      //   if (updateData.item === undefined) updateData.item = {} as {[k:string]: string};
      //   updateData.item[id] = autoNumber.result.value;
      //   updateLinkedData = updateLinkedData.map(item => {
      //     item.item = {};
      //     item.item[id] = autoNumber.result.value;
      //     return item;
      //   });
      // }

      if (updateData.related_ds_items === undefined) {
        updateData.related_ds_items = {};
      }
      updateData.related_ds_items[relatedDId] = [...updateLinkedData];

      try {
        const result = await this.changeStatus(
          projectId,
          mainDId,
          items[i].i_id,
          action.action_id as string,
          updateData
        );
        // エラーになった場合はエラー種別を特定しメッセージを取得
        if (this.isExsist(result)) {
          const errMessage = this.getErrMessage('EXECUTEACTION', result);
          if (errMessage.length > 0) errors.push({ ...items[i], ...{ error_message: errMessage } });
        }
      } catch (err) {
        errors.push({
          ...items[i],
          ...{ error_message: this.getErrMessage('DEFAULT', DefaultErrorCode) }
        });
      }
    }

    return errors;
  }

  public detailActionName(str: string): string {
    return str.replace('order_', 'order_detail_');
  }

  public async getCurrentItem(aId: string, dId: string, iId: string, excludeList: string[]) {
    const orderBasicResult = (await this.getLinkedItems(aId, dId, iId)) as GetItemDetailsResponse;
    // アイテム判定（発注アイテムが混在していないか）
    this.checkInitialItem(orderBasicResult, excludeList);
    return orderBasicResult;
  }
}
/* eslint-enable @typescript-eslint/camelcase */
